import { api } from "@/lib/api";

export async function getReputationRules() {
  const { data } = await api.get("/reputation/rules");
  return data;
}
export async function getMyReputation() {
  const { data } = await api.get("/reputation/me");
  return data;
}
export async function getLeaderboard() {
  const { data } = await api.get("/reputation/leaderboard");
  return data.items;
}

export const TIER_LABEL = {
  explorer: "Explorer",
  validator: "Validator",
  ambassador_eligible: "Ambassador eligible",
};
